export const BillingBannerEvents = {
  FAILED_PAYMENT_VIEW_INVOICES_CLICKED:
    "billing/failed-payment-banner-view-invoices-clicked",
  FAILED_PAYMENT_DISMISSED: "billing/failed-payment-banner-dismissed",
} as const;
